<div class="modal-bg scripts-dialog-backdrop">
    <div class="form modal-dialog-container scripts-dialog-container">

        <div class="dialog-header scripts-dialog-header">
            <div class="header-copy">
                <span class="dialog-eyebrow">Workspace</span>
                <h2 class="scripts-dialog-title">
                    <span>Speech recorder scripts</span>
                    <i class="fa fa-question-circle tooltip-zone-dark" aria-hidden="true" matTooltip="Here you can create scripts for the integrated speech recorder application. Each script consists of a number of prompts to be spoken by the subject. You can then link this script to a recording session in the recording sessions dialog."></i>
                </h2>
                <p>Create reusable prompt scripts and assign them to recording sessions.</p>
            </div>

            <div class="dialog-close-btn scripts-dialog-close-btn" (click)="closeDialog()">
                <i class="fa fa-times" aria-hidden="true"></i>
            </div>
        </div>

        <div class="scripts-dialog-content">
            <div class="actions-row">
                <button type="button" class="small-button form-add-button add-script-btn" (click)="addScript()">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    Add script
                </button>
            </div>

            <div class="scripts-loading" *ngIf="!scriptsLoaded">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                Loading scripts
            </div>

            <div class="empty-scripts" *ngIf="scriptsLoaded && scripts.length == 0">
                <h3>No recorder scripts yet</h3>
                <p>Create a script to define prompts for online recording sessions.</p>
            </div>

            <div class="scripts-list" *ngIf="scriptsLoaded && scripts.length > 0">
                <div class="script-card" *ngFor="let script of scripts" [ngClass]="{'readonly-script': !canEditScript(script)}">
                    <div class="script-card-main">
                        <div class="script-card-title-row">
                            <h3>{{ script.name }}</h3>
                            <span class="script-chip" [ngClass]="{'script-chip-shared': script.sharing == 'all'}">
                                <i class="fa" [ngClass]="script.sharing == 'all' ? 'fa-users' : 'fa-lock'" aria-hidden="true"></i>
                                {{ script.sharing == 'all' ? 'Shared' : 'Only me' }}
                            </span>
                            <span class="script-chip script-chip-readonly" *ngIf="!canEditScript(script)">Read only</span>
                        </div>
                        <div class="script-card-meta">
                            <span>{{ promptCount(script) }} {{ promptCount(script) == 1 ? 'prompt' : 'prompts' }}</span>
                        </div>
                        <ol class="script-preview" *ngIf="promptCount(script) > 0">
                            <li *ngFor="let prompt of script.prompts.slice(0, 3)">{{ prompt.value }}</li>
                        </ol>
                        <div class="script-card-note" *ngIf="promptCount(script) > 3">
                            {{ promptCount(script) - 3 }} more {{ promptCount(script) - 3 == 1 ? 'prompt' : 'prompts' }}
                        </div>
                    </div>

                    <div class="script-card-actions">
                        <button type="button" class="icon-action-btn" (click)="editScript(script)" [disabled]="!canEditScript(script)" aria-label="Edit script" title="Edit script">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="icon-action-btn danger-action" (click)="deleteSprScript(script, $event)" [disabled]="!canEditScript(script)" aria-label="Delete script" title="Delete script">
                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <app-spr-scripts-form *ngIf="editorOpen"
        [script]="scriptInEdit"
        [existingScriptNames]="existingScriptNames"
        [contextLabel]="editorContextLabel"
        [saveButtonLabel]="editorSaveButtonLabel"
        [footerNote]="editorFooterNote"
        (saved)="onScriptSaved($event)"
        (cancelled)="closeEditor()"></app-spr-scripts-form>
</div>
